import {
  StaticContentType,
  TopSectionData,
  VideoHeroData,
} from '@bm-js/atlascloud-shared'
import { TopSection, VideoHero } from '@bm-js/atlascloud-ui'
import LinkComponent from '../LinkComponent'
import { useEditorData } from '../../utils/hooks'

type Props = {
  content: StaticContentType<unknown>
}

const StaticContentSwitcher = ({ content }: Props) => {
  const { workingConfig } = useEditorData()
  switch (content.name) {
    case 'topsection':
      return (
        <TopSection
          content={content as StaticContentType<TopSectionData>}
          LinkComponent={LinkComponent}
        />
      )
    case 'videoHero':
      return (
        <VideoHero
          websiteBackground={workingConfig.websiteBackground}
          LinkComponent={LinkComponent}
          content={content as StaticContentType<VideoHeroData>}
        />
      )
    default:
      return null
  }
}

export default StaticContentSwitcher
